import React, { createContext, useState, useContext, useEffect } from 'react';
import Papa from 'papaparse';

// Create the context
const ManuscriptContext = createContext();

// Custom hook to use the manuscript context
export const useManuscripts = () => {
  return useContext(ManuscriptContext);
};

// Provider component
export const ManuscriptProvider = ({ children }) => {
  const [manuscripts, setManuscripts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const response = await fetch('/msdata/metadata.csv');
        const csvText = await response.text();

        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            setManuscripts(results.data);
            setLoading(false);
          },
          error: (error) => {
            console.error('Parse error:', error);
            setError('Failed to parse metadata');
            setLoading(false);
          }
        });
      } catch (err) {
        console.error('Fetch error:', err);
        setError('Failed to load metadata');
        setLoading(false);
      }
    };

    loadMetadata();
  }, []);

  // Find a manuscript by ID
  const getManuscriptById = (id) => {
    return manuscripts.find(ms => ms.manuscript_id === id) || null;
  };

  // Value to be provided to consuming components
  const value = {
    manuscripts,
    loading,
    error,
    getManuscriptById
  };

  return (
    <ManuscriptContext.Provider value={value}>
      {children}
    </ManuscriptContext.Provider>
  );
};

export default ManuscriptContext;